import { render, staticRenderFns } from "./CalendarioPage.html?vue&type=template&id=27b8a66d&external"
import script from "./CalendarioPage.vue?vue&type=script&lang=ts"
export * from "./CalendarioPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports